import httpUtil from "@/utils/httpUtil";
export const fetchWarehouseList = params => httpUtil.get("/stack/print", params);
export const fetchWarehouseDetails = params => httpUtil.get("/stack/getAllStore", params);